import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { InfoButton } from 'components/buttons'
import { updateProductFilters } from '../actions'
import { SECTIONS, FILTERS } from '../helpers'

export const InlineFiltersBase = ({
  onChange,
  defaultValues,
  inStockDisabled,
}) => (
  <InfoButton
    pill
    size="small"
    className="mrm"
    disabled={inStockDisabled}
    empty={!defaultValues[FILTERS.AVAILABLE]}
    onClick={() =>
      onChange({ [FILTERS.AVAILABLE]: !defaultValues[FILTERS.AVAILABLE] })
    }
  >
    {SECTIONS.IN_STOCK}
  </InfoButton>
)

InlineFiltersBase.propTypes = {
  onChange: PropTypes.func.isRequired,
  inStockDisabled: PropTypes.bool.isRequired,
  defaultValues: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({ defaultValues: state.productFilters })

const mapDispatchToProps = (dispatch) => ({
  onChange: (updatedValues) => dispatch(updateProductFilters(updatedValues)),
})

export const InlineFilters = connect(
  mapStateToProps,
  mapDispatchToProps
)(InlineFiltersBase)
